import React, { useState, useEffect, useRef } from 'react'

const PlanilhaPE = () => {
    const mediaWeb = window.matchMedia("(min-width:600px)").matches
    const iframeRef = useRef(null);
    let width = window.innerWidth;
    let tempHeight = window.innerHeight;
    let headerHeight = (9 / 100) * tempHeight;
    let height = tempHeight - headerHeight

    return (
        <>
            <iframe title="Report Section" ref={iframeRef}
                width={width}
                height={height}
                src="https://docs.google.com/spreadsheets/d/1DFeII8wvVNi2B-g2ZC9IlQSKcRP6wj7k3IdA2MJvGkY/edit?usp=sharing"
                frameborder="0"
                allowFullScreen="true"
            ></iframe>
        </>
    )
}

export default PlanilhaPE
